import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createDeposit } from '@/api/deposit.js';
import { listPayType } from '@/api/dict.js';
import { listSubsidiary } from '@/api/subsidiary.js';
import util from '@/libs/util.js';
import dayjs from 'dayjs';
export default {
  components: {},
  data: function data() {
    return {
      dialogTitle: '',
      dialogVisible: false,
      form: {},
      formRules: {
        collectionCompanyId: [{
          required: true,
          message: '请选择收款公司',
          trigger: ['change', 'blur']
        }],
        payType: [{
          required: true,
          message: '请选择付款方式',
          trigger: ['change', 'blur']
        }],
        receiptTime: [{
          required: true,
          message: '请选择付款日期',
          trigger: ['change', 'blur']
        }]
      },
      payTypeList: listPayType(),
      companyRow: {},
      subsidiaryList: [],
      uploadAction: process.env.VUE_APP_API + '/insideNew/upload',
      uploadToken: {},
      uploadFilePrefixURL: null,
      uploadPreviewURL: [],
      action: null,
      appRow: {
        subsidiarys: []
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    init: function init(appRow, action) {
      var that = this;
      that.action = action;
      that.appRow = appRow;
      that.dialogVisible = true;
      that.dialogTitle = '增加押金';
      that.uploadToken = {
        Authorization: util.cookies.get('token'),
        Os: 'web',
        PLATFORM: 'Web'
      };
      that.uploadFilePrefixURL = process.env.VUE_APP_OSS_URL + '/';

      if (appRow) {
        appRow.subsidiarys = appRow.subsidiarys || [];
        that.form = {
          manuId: appRow.manuId,
          productPrice: appRow.productPrice,
          toolPrice: appRow.toolPrice,
          payType: appRow.payType,
          optionType: appRow.optionType,
          // 1=增加 2=减少
          receiptTime: dayjs(appRow.receiptTime).format('YYYY-MM-DD'),
          mark: appRow.mark,
          pictureLicense: appRow.pictureLicense,
          // 凭证
          collectionCompanyId: appRow.collectionCompanyId,
          // 付款公司ID
          collectionCompanyName: appRow.collectionCompanyName,
          // 付款公司名称
          collectionCompanyBank: appRow.collectionCompanyBank,
          // 银行名称
          collectionCompanyBankAccount: appRow.collectionCompanyBankAccount,
          // 银行账号
          status: appRow.status,
          source: appRow.source
        };

        if (that.form.pictureLicense) {
          if (that.form.pictureLicense.length > 0) {
            that.form.pictureLicense.map(function (item) {
              that.uploadPreviewURL.push(that.uploadFilePrefixURL + item.url);
            });
          }
        }
      }

      that.loadSubsidiary();
    },
    dialogClose: function dialogClose() {
      var that = this;
      that.$emit('reload');
      that.dialogVisible = false;
    },
    formSubmit: function formSubmit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this;

                if (!(that.form.productPrice === 0 && that.form.toolPrice === 0)) {
                  _context2.next = 4;
                  break;
                }

                that.$message.error('货款押金增加金额/工具押金增加金额，不能同时为0');
                return _context2.abrupt("return");

              case 4:
                that.$refs.form.validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid, err) {
                    var loading, form, item;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!valid) {
                              _context.next = 18;
                              break;
                            }

                            loading = _this.$loading({
                              text: 'Loading...',
                              spinner: 'el-icon-loading',
                              background: 'rgba(0, 0, 0, 0.7)'
                            });
                            _context.prev = 2;
                            form = JSON.parse(JSON.stringify(that.form));
                            form.status = 2;
                            form.pictureLicense = form.pictureLicense ? JSON.stringify(form.pictureLicense) : '[]';
                            _context.next = 8;
                            return createDeposit(form);

                          case 8:
                            that.$notify.success('增加押金成功！');
                            that.dialogClose();
                            _context.next = 15;
                            break;

                          case 12:
                            _context.prev = 12;
                            _context.t0 = _context["catch"](2);
                            console.log(_context.t0.message);

                          case 15:
                            loading.close();
                            _context.next = 25;
                            break;

                          case 18:
                            _context.t1 = regeneratorRuntime.keys(err);

                          case 19:
                            if ((_context.t2 = _context.t1()).done) {
                              _context.next = 25;
                              break;
                            }

                            item = _context.t2.value;

                            _this.$message.error(err[item][0].message);

                            return _context.abrupt("return");

                          case 25:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[2, 12]]);
                  }));

                  return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    loadSubsidiary: function loadSubsidiary() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this2;
                query = {
                  page: 1,
                  pageSize: 9999
                };
                _context3.next = 4;
                return listSubsidiary(query).then(function (res) {
                  that.subsidiaryList = res.list;
                }).catch(function (e) {});

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    collectionCompanyIdChange: function collectionCompanyIdChange() {
      var that = this;
      var findRow = that.subsidiaryList.find(function (item) {
        return item.ID === that.form.collectionCompanyId;
      });

      if (findRow) {
        that.form.collectionCompanyName = findRow.companyName;
        that.form.collectionCompanyBank = findRow.bank;
        that.form.collectionCompanyBankAccount = findRow.bankAccount;
      }
    },
    uploadRemove: function uploadRemove(file, fileList) {
      var that = this;
      that.form.pictureLicense.forEach(function (item, idx) {
        if (item === file) {
          that.form.pictureLicense.splice(idx, 1);
        }
      });
    },
    uploadPreview: function uploadPreview(file) {
      var that = this;
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = that.uploadFilePrefixURL + file.url;
      link.setAttribute('download', file.name);
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    },
    uploadSuccess: function uploadSuccess(res, file, fileList) {
      var that = this;
      that.form.pictureLicense.push({
        url: file.response.data.file.url,
        name: file.response.data.file.name
      });
    },
    payTypeFormatter: function payTypeFormatter(payType) {
      var that = this;
      var findRow = that.payTypeList.find(function (item) {
        return item.ID === payType;
      });

      if (findRow) {
        return findRow.name;
      } else {
        return payType;
      }
    },
    moneyFormatter: function moneyFormatter(val) {
      return Number(val).toFixed(2);
    },
    reEdit: function reEdit() {
      var that = this;
      that.action = 'EDIT';
      that.status = 1;
    }
  }
};